import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { SUPPORTED_LANGUAGE_CODES } from "./supportedLanguages";

const TRANSLATION_RESOURCE_BY_LANGUAGE: Record<string, string> = {
  ar: "ar-SA",
  da: "da-DK",
  de: "de-DE",
  el: "el-GR",
  fa: "fa-IR",
  fi: "fi-FI",
  fr: "fr-FR",
  he: "he-IL",
  hi: "hi-IN",
  id: "id-ID",
  it: "it-IT",
  ms: "ms-MY",
  nb: "nb-NO",
  nl: "nl-NL",
  pl: "pl-PL",
  ru: "ru-RU",
  sv: "sv-SE",
  th: "th-TH",
  tr: "tr-TR",
  uk: "uk-UA",
  vi: "vi-VN",
};

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: [...SUPPORTED_LANGUAGE_CODES],
    fallbackLng: "en",
    debug: false,
    detection: {
      order: ["htmlTag", "navigator"],
      caches: [],
    },
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: (languages: string[]) => {
        const requested = languages[0] ?? "en";
        const resourceLanguage =
          TRANSLATION_RESOURCE_BY_LANGUAGE[requested] ?? requested;

        return `/locales/${resourceLanguage}/translation.json?v=20260830-1`;
      },
    },
  });

export default i18n;
